import { Components } from "@mui/material"

export default function MenuItemTheme(): Components {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {},
      },
    },
  }
}
